import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { Button } from '@knowledgehound/laika'

import { getClientBase } from 'store/configurationDuck'
import { getIsEmbedded } from 'store/DatasetSelectors'
import { clearAnalysisData, removeVariableThunk } from 'store/DatasetActions'

import * as styles from './OpenEndedVariableRedirectOverlay.module.scss'

const propTypes = {
  variable: PropTypes.shape({
    id: PropTypes.string, // name+type
    questionName: PropTypes.string.isRequired, // the question reference id within a dataset, such as ageres
    question_type: PropTypes.string,
    variableNk: PropTypes.string.isRequired, // natural key (study number, dataset name, question id)
    label: PropTypes.string.isRequired, // The variable/question text
  }).isRequired,
}

const OpenEndedVariableRedirectOverlay = ({ variable }) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const history = useHistory()
  const clientBase = useSelector(getClientBase, shallowEqual)
  const isEmbedded = useSelector(getIsEmbedded, shallowEqual)
  const handleCancel = async e => {
    dispatch(clearAnalysisData())
    await dispatch(removeVariableThunk(variable.variableNk))
  }

  return (
    <React.Fragment>
      <div className={styles.stateOverlay}>
        <div className={styles.content}>
          <p className={styles.title}>
            {intl.formatMessage({
              id: `analysis.openEndGate.title.${isEmbedded ? 'embedded' : 'notEmbedded'}`,
            })}
          </p>
          <p className={styles.body}>
            {intl.formatMessage({
              id: `analysis.openEndGate.body.${isEmbedded ? 'embedded' : 'notEmbedded'}`,
            })}
          </p>
          <div className={isEmbedded ? styles.embedControls : styles.controls}>
            <Button onClick={() => dispatch(handleCancel)} variant="secondary">
              {intl.formatMessage({
                id: `analysis.openEndGate.${isEmbedded ? 'analyzeOtherQuestions' : 'cancel'}`,
              })}
            </Button>
            <Button
              onClick={() => {
                const param = encodeURI(variable.variableNk)
                if (isEmbedded) {
                  window.location.assign(
                    `https://${clientBase}.knowledgehound.co/open-analysis/${param}`
                  )
                } else {
                  history.push(`/open-analysis/${param}`)
                }
              }}
              variant="primary"
            >
              {intl.formatMessage({
                id: `analysis.openEndGate.cta`,
              })}
            </Button>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

OpenEndedVariableRedirectOverlay.propTypes = propTypes
export default OpenEndedVariableRedirectOverlay
